'use strict';

function Control() {
   var $Controls = $('[data-control]');
   var ActiveControl = '';
   var $ActiveControlElm = null;
   var RefreshCallbacks = [];
   var ChangeCallbacks = [];
   var PreChangeCallbacks = [];
   var PostChangeCallbacks = [];
   var self = this;

   this.SetActiveControl = function($Elm) {
      ActiveControl = $Elm.data('control');
      $ActiveControlElm = $Elm;

      var PreCallbacks = PreChangeCallbacks;
      var PostCallbacks = PostChangeCallbacks;
      PreChangeCallbacks = [];
      PostChangeCallbacks = [];

      $.each(PreCallbacks, function() {
         this(ActiveControl, $ActiveControlElm);
      });

      $.each(ChangeCallbacks, function() {
         this(ActiveControl, $ActiveControlElm);
      });

      this.Refresh();

      $.each(PostCallbacks, function() {
         this(ActiveControl, $ActiveControlElm);
      });
   };

   this.Refresh = function() {
      $Controls.each(function() {
         $(this).attr('aria-selected', $(this).data('control') === ActiveControl);
      });
      $.each(RefreshCallbacks, function() {
         this(ActiveControl, $ActiveControlElm);
      });
   };

   this.AddRefreshCallback = function(Callback) {
      RefreshCallbacks.push(Callback);
      Callback(ActiveControl, $ActiveControlElm);
   };

   this.AddChangeCallback = function(Callback) {
      ChangeCallbacks.push(Callback);
      Callback(ActiveControl, $ActiveControlElm);
   };

   this.AddPreChangeCallback = function(Callback) {
      PreChangeCallbacks.push(Callback);
   };

   this.AddPostChangeCallback = function(Callback) {
      PostChangeCallbacks.push(Callback);
   };

   $Controls.filter('[aria-selected="true"]').each(function() {
      self.SetActiveControl($(this));
   });

   if('' !== document.location.hash) {
      $Controls.filter('[data-control="'+document.location.hash.substr(1)+'"]').each(function() {
         self.SetActiveControl($(this));
      });
   }

   $Controls.each(function() {
      $(this).on('click', function() {
         self.SetActiveControl($(this));
      });
   });

   this.Refresh();

   // TODO Support grouping of controls
}

function VisibilityInput($Elm, $Input, Value) {
   Value = String(Value);
   if(!$.isArray(Value))
      Value = [Value];

   function ChangeInput() {
      if(-1 !== $.inArray($Input.val(), Value))
         $Elm.show();
      else
         $Elm.hide();
   }

   ChangeInput();

   $Input.bind('input change keyup paste', ChangeInput);
}

function FormEnabledInput($Elm, $Input, Value) {
   Value = String(Value);
   if(!$.isArray(Value))
      Value = [Value];

   function ChangeInput() {
      if(-1 !== $.inArray($Input.val(), Value))
         $Elm.find(':input').addBack(':input').not($Elm.find('[data-form-enabled-prop], [data-form-enabled-input]').find(':input')).prop('disabled', false);
      else
         $Elm.find(':input').addBack(':input').prop('disabled', true);
   }

   ChangeInput();

   $Input.bind('input change keyup paste', ChangeInput);
}

function FormEnabledProp($Elm, Prop) {
   function ChangeInput() {
      if($Elm.prop(Prop))
         $Elm.find(':input').addBack(':input').not($Elm.find('[data-form-enabled-prop], [data-form-enabled-input]').find(':input')).prop('disabled', false);
      else
         $Elm.find(':input').addBack(':input').prop('disabled', true);
   }

   ChangeInput();

   $Elm.bind('toggle', ChangeInput);
}

$.fn.SerializeObject = function() {
   var O = {};
   var A = this.serializeArray();
   $.each(A, function() {
      if('[]' === this.name.substr(-2)) {
         if(!(this.name in O))
            O[this.name] = [];
         O[this.name].push(this.value);
      } else {
         O[this.name] = this.value;
      }
   });
   return O;
};

$.uncamelCase = function(String) {
   return String.replace(/([A-Z])/g, '-$1').toLowerCase().replace(/^-/, '');
};

function RemoveAlias(Object, Alias) {
   var O = {};
   $.each(Object, function(Key, Value) {
      if(Key.substr(0, Alias.length) === Alias)
         O[Key.substr(Alias.length)] = Value;
   });
   return O;
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
function EscapeRegExp(string) {
   return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

$(function() {
   var Notificator =
   {  Container: $('#dynamic-notifications').find('ul')
   ,  AddNotification: function(Message) {
         var $Element = $('<li class="row" style="display: none;">');
         var $Text = $('<span class="col-xs-11">'+Message+'</li>');
         var $Close = $('<a class="col-xs-1 icon icon-md icon-x-white text-hide">' + i18n.gettext('Close') + '</a>');
         $Element.append($Text);
         $Element.append($Close);
         this.Container.append($Element);

         var CloseFunction = this.RemoveNotification.bind(this, $Element);
         $Close.on('click', CloseFunction);
         $Element.CloseTimeout = setTimeout(CloseFunction, 10000);

         $Element.slideDown();
      }
   ,  RemoveNotification: function($Element) {
         clearTimeout($Element.CloseTimeout);
         $Element.slideUp({complete: function() {
            $Element.remove();
         }});
      }
   }

   function RemoveKeyFromQuery(Query, Key) {
      var PlainKey = -1 === Key.indexOf('[') ? Key : Key.substr(0, Key.indexOf('['));

      // Create intermediate array to avoid altering searchParams while iterating over it.
      var Keys = Array.from(Query.keys());

      for(var Key in Keys)
         if(Keys[Key] === PlainKey || Keys[Key].substr(0, PlainKey.length + 1) === PlainKey + '[')
            Query.delete(Keys[Key]);
   }

   var Controller = new Control();


   $('[data-visibility-input]').each(function() {
      new VisibilityInput($(this), $($(this).data('visibility-input')), $(this).data('visibility-value'));
   });


   $('[data-form-enabled-input]').each(function() {
      new FormEnabledInput($(this), $($(this).data('form-enabled-input')), $(this).data('form-enabled-value'));
   });

   $('[data-form-enabled-prop]').each(function() {
      new FormEnabledProp($(this), $(this).data('form-enabled-prop'));
   });


   Controller.AddRefreshCallback(function(ActiveControl) {
      $('[data-control-visibility]').each(function() {
         var Value = $(this).data('control-visibility');
         if(!$.isArray(Value))
            Value = [Value];

         var Show = -1 !== $.inArray(ActiveControl, Value);

         if('undefined' !== typeof $(this).data('control-visibility-negate'))
            Show = !Show;

         if(Show) {
            $(this).show();
         } else {
            $(this).hide();
            this.style.setProperty('display', 'none', 'important'); // To override !important css rules
         }
      });
   });

   Controller.AddRefreshCallback(function(ActiveControl) {
      $('[data-control-form-enabled]').each(function() {
         var Value = $(this).data('control-form-enabled');
         var Enabled = ActiveControl === Value;
         if($.isArray(Value))
            Enabled = -1 !== $.inArray(ActiveControl, Value);

         if(Enabled)
            $(this).find(':input').addBack(':input').prop('disabled', false);
         else
            $(this).find(':input').addBack(':input').prop('disabled', true);
      });
   });


   $('[data-action-click]').each(function() {
      var $Element = $(this);
      var Value = $(this).data('action-click');

      $Element.on('click', function(Event) {
         $.each(Value, function() {
            var Parameters = this;
            if(!$.isArray(Parameters))
               Parameters = [Parameters];

            switch(Parameters[0]) {
               case 'ajax-post':
                  $.post($Element.attr('href'), {ReturnType: null});
                  break;
               case 'slide-down':
                  $(Parameters[1]).slideUp();
                  break;
               case 'prevent-default':
                  Event.preventDefault();
                  break;
            }
         });
      });
   });


   // Open accordion if it contains the fragment element
   $(document.location.hash).parents('details').addBack('details').attr('open', true);

   function InitAccordion($Element) {
      $Element.each(function() {
         var $Summary = $(this);
         var $Details = $(this).parent();
         var $Wrapper = $Summary.siblings().wrapAll('<div></div>').parent();

         if(!$Details.attr('open'))
            $Wrapper.hide();

         $Summary.click(function(Event) {
            Event.preventDefault();
            if($Details.attr('open')) {
               $Wrapper.slideUp(function() {
                  $Details.removeAttr('open');
               });
            } else {
               $Details.attr('open', true);
               $Wrapper.slideDown();
            }
         });
      });
   };
   InitAccordion($('details > summary'));

   // Open accordion when the fragment element is changed
   $(window).on('hashchange', function() {
      $(document.location.hash).parents('details').addBack('details').attr('open', true);
      $(document.location.hash).parents('details').addBack('details').children(':not(summary)').slideDown();
   });


   // Initialize jQuery.dotdotdot (https://github.com/FrDH/jQuery.dotdotdot)
   $('[data-dotdotdot]').dotdotdot(
      {  watch: 'window'
      }
   );


   function InitFancyBox($Element) {
      // Initialize fancyBox (https://github.com/fancyapps/fancyBox)
      $Element.fancybox(
         {  baseClass: 'fancybox-theme-dynaplan'
         ,  animationEffect: 'fade'
         ,  transitionEffect: 'slide'
         ,  infobar: true
         ,  touch: false // Make it possible to select text in slide
         }
      );
   }
   InitFancyBox($('[data-fancybox]'));


   // Initialize jquery-smooth-scroll (https://github.com/kswedberg/jquery-smooth-scroll)
   $('a:not([data-fancybox])').smoothScroll(
      {  beforeScroll: function(Options) {
            if(history.replaceState) {
               history.replaceState(null, null, Options.scrollTarget);
               $(window).trigger('hashchange');
            }
         }
      }
   );


   $.fn.select2.amd.define
   (  'IconSelect'
   ,  [  'select2/utils'
      ,  'select2/selection/single'
      ,  'select2/selection/eventRelay'
      ]
   ,  function(Utils, SingleSelection, EventRelay) {
         var Adapter = SingleSelection;
         Adapter = Utils.Decorate(Adapter, EventRelay);
         return Adapter;
      }
   );

   $.fn.select2.amd.define
   (  'IconDropdown'
   ,  [  'select2/utils'
      ,  'select2/dropdown'
      ,  'select2/dropdown/search'
      ,  'select2/dropdown/attachBody'
      ]
   ,  function(Utils, Dropdown, Search, AttachBody) {
         var Adapter = Dropdown;
         Adapter = Utils.Decorate(Adapter, Search);
         Adapter = Utils.Decorate(Adapter, AttachBody);
         return Adapter;
      }
   );

   function InitSelect2($Element, Theme) {
      // Initialize Select2 (https://github.com/select2/select2)
      var Options =
      {  escapeMarkup: function(Markup) {return Markup;}
      ,  theme: 'dynaplan'+('undefined' === typeof Theme ? '' : ' select2-dynaplan-'+Theme)
      ,  minimumResultsForSearch: 7
      //   ,  createTag: function(Params) {
      //         var Term = $.trim(Params.term);
      //
      //         if('' === Term)
      //            return null;
      //
      //         return {
      //            id: Term,
      //            text: Term,
      //            tag: true
      //         };
      //      }
      //   }).on('select2:selecting', function(Event) {
      //      console.log('selecting');
      //      console.log(Event);
      //      if(Event.params.args.data.tag) {
      //         // TODO Create the <input> for creating a new tag and set the id of the new item correctly
      ////         Event.params.args.data.id = 'bar';
      //      }
      //   }).on('select2:select', function(Event) {
      //      console.log('select');
      //      console.log(Event);
      //   }).on('change', function(Event) {
      //      console.log('change');
      //      console.log(Event);
      //   }).on('select2:unselecting', function(Event) {
      //      console.log('unselecting');
      //      console.log(Event);
      //   }).on('select2:unselect', function(Event) {
      //      console.log('unselect');
      //      console.log(Event);
      //      if(Event.params.data.tag) {
      //         // TODO Remove the created <input> for the new tag
      //      }
      };

      var BuildValues = function(InputValues) {
         var Values = {};
         $.each(InputValues, function(Key) {
            if(isNaN(Key)) {
               Values[Key] = this;
            } else {
               var Element = $('#'+$.escapeSelector(this));
               var Name = 'undefined' !== typeof Element.data('filter-name') ? Element.data('filter-name') : this;
               if('checkbox' === Element.attr('type')) {
                  Values[Name] = Element.prop('checked');
               } else {
                  var Value = Element.val();
                  // jQuery prior to version 3 returns null for multiselect with no option selected
                  if(null !== Value)
                     Values[Name] = Value;
               }
            }
         });
         return Values;
      };

      var AjaxOptions = $.extend({}, Options,
      {  ajax:
         {  delay: 500
         ,  url: function() {return $(this).data('select2-ajax');}
         ,  data: function(Parameters) {
               if('undefined' !== typeof this.data('loader-functions')) {
                  $.extend(Parameters, BuildValues(this.data('loader-functions')[0]));
                  Parameters['populate-values'] = BuildValues(this.data('loader-functions')[1]);
               }
               return Parameters;
            }
         ,  processResults: function(Data) {
               var DisableValues = this.$element.data('disable-values');
               if('undefined' !== typeof DisableValues) {
                  $.each(Data.results, function(Index, Item) {
                     if(-1 !== $.inArray(Item.id, DisableValues))
                        Item.disabled = true;
                  });
               }
               return Data;
            }
         }
      });

      $Element.each(function() {
         var CurrentOptions = 'undefined' === typeof $(this).data('select2-ajax') ? Options : AjaxOptions;
         if('icon' === $(this).data('plugin-select2')) {
            CurrentOptions.theme += ' select2-dynaplan-narrow select2-dynaplan-icon';
            $.extend(CurrentOptions, {
               dropdownAdapter: $.fn.select2.amd.require('IconDropdown'),
               dropdownAutoWidth: true,
               selectionAdapter: $.fn.select2.amd.require('IconSelect'),
               templateSelection: function() { return ''; },
               width: '18px'
            });
         }

         var $SelectElm = $(this).select2(CurrentOptions);
         var Select2 = $SelectElm.data('select2');
         var SearchContainer = $(this).data('select2-search-container');

         if(SearchContainer) {
            var $SearchContainer = $(SearchContainer);
            if('undefined' !== typeof Select2.dropdown.$searchContainer)
               var $SearchElm = Select2.dropdown.$search; // Single select
            else
               var $SearchElm = Select2.selection.$search; // Multiple select

            $SearchContainer.find('input, select').bind('input change keyup paste', function() {
               $SearchElm.trigger('input');
               $SearchElm.trigger('keyup'); // For browsers that do not support input
            });
            $SearchContainer.bind('select2:select', function() {
               $SearchElm.focus();
            });
            $SearchContainer.bind('select2:close', function() {
               setTimeout(function() { $SearchElm.focus(); }, 5);
            });

            InitSelect2($SearchContainer.find('[data-plugin-select2]'), 'dark');
            $SearchContainer.find('[data-select2-search]').append($SearchElm);

            if('undefined' === typeof Select2.dropdown.$searchContainer)
               Select2.results.$results.before($SearchContainer); // Multiple select
            else
               Select2.dropdown.$searchContainer.append($SearchContainer); // Single select
         }
      });
   }
   InitSelect2($('[data-plugin-select2]'));

   // When only icon is shown, indicate whether any options are selected.
   $('[data-plugin-select2="icon"]').on('change', function(Event) {
      $(this).data('select2').$selection.toggleClass('select2-has-selection', $(this).val() !== null);
   });
   $('[data-plugin-select2="icon"]').trigger('change');


   // Initialize DataTables (https://github.com/DataTables/DataTables)
   $.fn.dataTable.ext.pager.numbers_length = 11;
   $.fn.dataTable.ext.errMode = 'throw';

   $.fn.dataTable.ext.search.push(
      function(Settings, SearchData, RowIndex, RowData, Counter) {
         // Only when using client-side filtering.
         if(null !== Settings.ajax)
            return true;

         var Api = new $.fn.dataTable.Api(Settings);

         var ShowRow = function(Filter, Alias) {
            if(Filter.name === Alias+'filter-selection') {
               var FilterSelected = $(Filter).prop('checked');
               return !FilterSelected || Api.cell(RowIndex, 0).nodes().to$().find('[data-form-filter-type="selection"]').prop('checked');
            } else if(Filter.name !== Alias+'filter') {
               var FilterValues = $(Filter).val();
               if(null !== FilterValues) {
                  var Values = Api.row(RowIndex).nodes().to$().children('[data-form-filter-type="'+$.escapeSelector(Filter.name)+'"]').data('form-filter-values');
                  Values = Values.map(String);

                  for(var J = 0; J < FilterValues.length; ++J)
                     if(-1 !== Values.indexOf(FilterValues[J]))
                        return true;
                  return false;
               }
            }
            return true;
         };

         var $Filters = $(Api.table().header()).find('[data-form-filter]');
         for(var I = 0; I < $Filters.length; ++I) {
            if(!ShowRow($Filters[I], ''))
               return false;
         };

         var FilterForm = $(Api.table().node()).data('filter-form');
         if('undefined' !== typeof FilterForm) {
            var Alias = $(FilterForm).data('form-alias') || '';
            if('' !== Alias)
               Alias += '-';

            var $Filters = $(FilterForm).find('[data-form-filter]');
            for(var I = 0; I < $Filters.length; ++I)
               if(!ShowRow($Filters[I], Alias))
                  return false;
         }

         return true;
      }
   );

   $('[data-datatables]').on('preInit.dt', function(Event, Settings) {
      var TableId = this.id;
      var Api = new $.fn.dataTable.Api(Settings);
      var $Container = $(Api.table().container());

      $(this).find('thead th a').on('click', function(Event) {Event.preventDefault();});
      var $Wrapper = $Container.closest('.datatables--dynaplan');
      $Wrapper.find('[data-datatables-hide]').hide();
      $Wrapper.find('[data-datatables-move]').each(function(){$Wrapper.find('.datatables-move-'+$(this).data('datatables-move')).append($(this));});
      $Container.parents('[data-datatables-reset="width"]').each(function(){$(this).css('width', 'auto');});
      $Container.parents('[data-datatables-reset="padding"]').each(function(){$(this).css('padding', 0);});

      var DataTablesSearch;
      if(null === Settings.ajax) {
         DataTablesSearch = Api.draw;
      } else {
         var DebouncedDataTablesSearch = $.debounce(250, function() { // Debounce search
            Api.search('').draw(); // Clear any search query set on the table
         });
         DataTablesSearch = function() {
            $(Api.table().node()).dataTable()._fnProcessingDisplay(true);
            DebouncedDataTablesSearch();
         };
      }

      function ListenToFilter($FilterContainer, Alias) {
         $FilterContainer.find('[data-form-filter]').each(function() {
            if(!this.hasOwnProperty('OldValue'))
               this.OldValue = {};
            if(!this.hasOwnProperty('OldChecked'))
               this.OldChecked = {};
            this.OldValue[TableId] = $(this).val();
            this.OldChecked[TableId] = $(this).prop('checked');
            $(this).bind('input change keyup paste', function() {
               if(this.OldValue[TableId] !== $(this).val() || this.OldChecked[TableId] !== $(this).prop('checked')) {
                  if('ordering' === $(this).data('form-filter-reset'))
                     Api.order([]); // Reset ordering to let results be ordered by relevance.
                  this.OldValue[TableId] = $(this).val();
                  this.OldChecked[TableId] = $(this).prop('checked');
                  if(this.name === Alias+'filter')
                     Api.search(this.OldValue[TableId]);

                  // Write filter into url.
                  var Url = new URL(window.location.href);
                  RemoveKeyFromQuery(Url.searchParams, this.name);

                  var Value = $(this).val();
                  if('' !== Value && null !== Value && !$(this).is('input:checkbox:not(:checked)')) {
                     if(!Array.isArray(Value))
                        Value = [Value];

                     for(var Val in Value)
                        Url.searchParams.append(this.name, Value[Val]);
                  }

                  history.replaceState(null, '', Url);

                  DataTablesSearch();
               }
            });
         });
      }

      ListenToFilter($(Api.table().header()), '');

      var FilterForm = $(this).data('filter-form');
      if('undefined' !== typeof FilterForm) {
         var Alias = $(FilterForm).data('form-alias') || '';
         if('' !== Alias)
            Alias += '-';

         ListenToFilter($(FilterForm), Alias);

         Api.on('preXhr', function(Event, Settings, Data) {
            $.extend(Data, RemoveAlias($(FilterForm).find('input, select').SerializeObject(), Alias));
         });

         if($(FilterForm).filter('form').length) {
            $(FilterForm).on('submit', false);
         } else {
            $(FilterForm).on('keydown', function(Event) {
               if(13 === Event.keyCode) { // Enter
                  Event.preventDefault();
                  return false;
               }
            });
            $(FilterForm).find('input[type="submit"], button[type="submit"]').on('click', function(Event) {
               Event.preventDefault();
               return false;
            });
         }
      }
   });
   $('[data-datatables]').on('init.dt', function(Event, Settings) {
      var Api = new $.fn.dataTable.Api(Settings);
      var $Container = $(Api.table().container());
      InitSelect2($Container.find('.dataTables_length select'), 'narrow');
      if(0 === Api.page.info().recordsTotal)
         $Container.find('.dataTables_info, .dataTables_paginate').hide();
   });
   $('[data-datatables]').on('page.dt', function(Event, Settings) {
      var Api = new $.fn.dataTable.Api(Settings);
      var FilterForm = $(Api.table().node()).data('filter-form');
      $.smoothScroll({scrollTarget: 'undefined' === typeof FilterForm ? Api.table().container() : $(FilterForm)})
   });

   var DataTablesAjaxResponse = function(Json, $DataTable) {
      var $Container = $($DataTable.DataTable().table().container()).find('.datatables-notifications');
      if(Json.hasOwnProperty('notifications')) {
         var $Notifications = $('<ul>');
         $.each(Json.notifications, function() {
            var $Notification = $('<li>');
            $Notification.html(this);
            $Notifications.append($Notification);
         });
         $Container.empty();
         $Container.append($Notifications);
         $Container.show();
      } else {
         $Container.empty();
         $Container.hide();
      }
   };

   // Note: page.info().start is not always reliable. https://datatables.net/forums/discussion/69531/page-info-start-is-incorrect-on-predraw
   //       When the issue is fixed, this can be moved into preDraw, and not have to be called on draw or preXhr.
   function DataTableUpdateUrl(DataTable) {
      var Url = new URL(window.location.href);
      var Page = DataTable.page.info();

      // Write page into url.
      if(true === DataTable.PageCanBeTrusted) {
         RemoveKeyFromQuery(Url.searchParams, 'start');
         if(0 !== Page.start)
            Url.searchParams.append('start', Page.start);
      }

      // Write page length into url.
      RemoveKeyFromQuery(Url.searchParams, 'length');
      var DefaultPageLength = $(DataTable.table().node()).data('default-page-length');
      if(DefaultPageLength !== Page.length)
         Url.searchParams.append('length', Page.length);

      // Write ordering into url.
      RemoveKeyFromQuery(Url.searchParams, 'order');
      var Order = DataTable.order();
      for(var I in Order) {
         Url.searchParams.append('order['+I+'][column]', Order[I][0]);
         Url.searchParams.append('order['+I+'][dir]', Order[I][1]);
      }

      history.replaceState(null, '', Url);
   }

   function InitDataTables($Element, Options) {
      $Element.each(function() {
         var $This = $(this);

         $.extend(Options,
         {  order: []
         ,  pagingType: 'full_numbers'
         ,  conditionalPaging: true
         ,  processing: true
         ,  columnDefs:
            [  {targets: 'js-datatables-nosort', orderable: false}
            ,  {targets: 'js-datatables-sort-desc', orderSequence: ['desc', 'asc']}
            ]
         ,  drawCallback: function(Settings) {
               this.api().columns().every(function() {
                  var Column = this;
                  $.each($(Column.header()).data(), function(Key) {
                     Column.nodes().to$().attr('data-'+$.uncamelCase(Key), typeof this in {string: true, number: true} ? this : JSON.stringify(this));
                  });
                  $.each(['hidden', 'text-center', 'text-right', 'visible-xs', 'visible-sm', 'visible-md', 'visible-lg'], function() {
                     if($(Column.header()).hasClass(this))
                        Column.nodes().to$().addClass(this);
                  });
               });
               var $Rows = this.api().rows().nodes().to$();
               InitSelect2($Rows.find('[data-plugin-select2]'));
               InitFancyBox($Rows.find('[data-fancybox]'));
               Controller.Refresh();
               // TODO disable Select when it should not be enabled

               this.api().PageCanBeTrusted = true;
               DataTableUpdateUrl(this.api());
            }
         ,  preDrawCallback: function(Settings) {
               DataTableUpdateUrl(this.api());
            }
         });

         if('undefined' !== typeof Options.select && false !== Options.select) {
            $.extend(Options, {
               initComplete: function() {
                  var DataTable = this.api();
                  $(DataTable.rows().data()).each(function(I) {
                     var $Elm = $(this[0]).filter('input[type="checkbox"]');
                     if($Elm.prop('checked'))
                        DataTable.row(I).select();
                  });
               }
            });
         }

         var AjaxOptions =
         {  ajax:
            {  url: $(this).data('datatables-ajax')
            ,  dataSrc: function(Json) {
                  DataTablesAjaxResponse(Json, $This);
                  return Json.data;
               }
            ,  error: function(Xhr) {
                  DataTablesAjaxResponse(Xhr.responseJSON, $This);
                  $This.dataTable()._fnProcessingDisplay(false);
               }
            }
         };

         var $DataTable = $This.DataTable('undefined' === typeof $(this).data('datatables-ajax') ? Options : $.extend({}, Options, AjaxOptions));

         $DataTable.on('preXhr', function(Event, Settings) {
            var Api = new $.fn.dataTable.Api(Settings);
            Api.PageCanBeTrusted = true;
            DataTableUpdateUrl(Api);
         });

         if('undefined' !== typeof Options.select && false !== Options.select) {
            var TickRows = function(DataTable, Indexes, Checked) {
               $.each(Indexes, function() {
                  var Checkbox = $(DataTable.cell(this, 0).node()).children('input[type="checkbox"]');
                  Checkbox.prop('checked', Checked);
                  Checkbox.trigger('change');
               });

               var Checkbox = DataTable.row(0).nodes().to$().find('[data-form-select]');
               if(0 !== Checkbox.length) {
                  // Write selection into url.
                  var Url = new URL(window.location.href);
                  Checkbox.each(function() {
                     RemoveKeyFromQuery(Url.searchParams, this.name);
                  });

                  DataTable.rows({ selected: true }).nodes().to$().find('[data-form-select]').each(function() {
                     if(this.checked)
                        Url.searchParams.append(this.name, $(this).val());
                  });

                  history.replaceState(null, '', Url);
               }
            };

            // Tick checkbox when selecting row.
            $DataTable.on('select', function(Event, DataTable, Type, Indexes) {
               if('row' === Type)
                  TickRows(DataTable, Indexes, true);
            });

            // Untick checkbox when deselecting row.
            $DataTable.on('deselect', function(Event, DataTable, Type, Indexes) {
               if('row' === Type)
                  TickRows(DataTable, Indexes, false);
            });

            // Allow clicking links without (de)selecting the row.
            $DataTable.on('user-select', function(Event, DataTable, Type, Cell, OriginalEvent) {
               if('a' === OriginalEvent.target.nodeName.toLowerCase())
                  Event.preventDefault();
            });
         }
      });
   }

   InitDataTables
   (  $('[data-datatables="listing"]')
   ,  {  dom: '<"pos-r"<"text-hide"r><"datatables-notifications">t>ip'
      }
   );

   InitDataTables
   (  $('[data-datatables="table"]')
   ,  {  dom: '<"container"<"row"<"col-xs-12"<"pos-r"<"text-hide"r><"datatables-notifications">t<"datatables-move-buttons">>>>><"form-filter-footer text-center"<"container"<"row"<"col-xs-12"pil>>>>'
      ,  lengthMenu: [[10, 25, 50, 100, 1000, -1], [10, 25, 50, 100, 1000, 'All']]
         // TODO: Change hrefs on pagination and column headers when sorting/filtering/paging. Create a pagination plug-in? https://datatables.net/plug-ins/pagination/
//      ,  drawCallback: function() {
//            var DataTable = this.api();
//            console.log(DataTable.draw('page'));
//         }
      ,  initComplete: function() {
            // Shift+click support for both rows and columns.
            var $LastChecked = null;

            var Selector = ':checkbox:visible:not(:disabled)';
            this.on('click', Selector, function(Event) {
               var $Checkbox = $(Event.target);

               if(Event.shiftKey && null !== $LastChecked) {
                  var RowIndex = $Checkbox.closest('tr').index();
                  var LastRowIndex = $LastChecked.closest('tr').index();
                  var ColIndex = $Checkbox.closest('td').index();
                  var LastColIndex = $LastChecked.closest('td').index();

                  var StartRow = Math.min(RowIndex, LastRowIndex);
                  var EndRow = Math.max(RowIndex, LastRowIndex);
                  var StartCol = Math.min(ColIndex, LastColIndex);
                  var EndCol = Math.max(ColIndex, LastColIndex);
                  var $Checkboxes = $Checkbox.closest('tbody').find('>tr:nth-child(n+'+(StartRow+1)+'):nth-child(-n+'+(EndRow+1)+')>td:nth-child(n+'+(StartCol+1)+'):nth-child(-n+'+(EndCol+1)+') ' + Selector);

                  $Checkboxes.prop('checked', $Checkbox.prop('checked')).trigger('change');
               }
               $LastChecked = $Checkbox;
            });
         }
      }
   );

   InitDataTables
   (  $('[data-datatables="checkbox"]')
   ,  {  dom: '<"container"<"row"<"col-xs-12"<"pos-r"<"text-hide"r><"datatables-notifications">t<"datatables-move-buttons">>>>><"form-filter-footer text-center"<"container"<"row"<"col-xs-12"pilB>>>>'
      ,  lengthMenu: [[10, 25, 50, 100, 1000, -1], [10, 25, 50, 100, 1000, 'All']]
      ,  buttons: {name: 'select', buttons: ['selectAll', 'selectNone']}
      ,  select: {style: 'multi+shift'}
      }
   );

   InitDataTables
   (  $('[data-datatables="hr-measures"]')
   ,  {  dom: '<"container"<"row"<"col-xs-12"<"pos-r"t>>>><"form-filter-footer text-center dt-info-inline"iB>'
      ,  select: {style: 'multi+shift'}
      ,  ordering: false
      ,  buttons:
         [  {  action: function() {
                  navigator.clipboard.writeText(window.location.href);
                  Notificator.AddNotification(i18n.gettext('A URL with the current filtering and selection has been copied to the clipboard.'));
               }
            ,  className: '_button'
            ,  extend: 'selected'
            ,  text: '<span>' + i18n.gettext('Copy URL') + '</span><i class="_icon-internal-white"></i>'
            }
         ]
      }
   );


   Controller.AddChangeCallback(function(ActiveControl, $ActiveControlElm) {
      if(null !== $ActiveControlElm && 'undefined' !== typeof $ActiveControlElm.data('control-datatables')) {
         var DataTable = $($ActiveControlElm.data('control-datatables')).DataTable();

         if('undefined' !== typeof $ActiveControlElm.data('control-datatables-select')) {
            var CurrentSelectStyle = DataTable.select.style();
            var NewSelectStyle = $ActiveControlElm.data('control-datatables-select');
            if(false === NewSelectStyle) {
               NewSelectStyle = 'api';
               DataTable.buttons('select', null).nodes().hide();
            } else {
               DataTable.buttons('select', null).nodes().show();
            }
            if(NewSelectStyle !== CurrentSelectStyle)
               DataTable.rows().deselect();
            DataTable.select.style(NewSelectStyle);
         }
      }
   });


   Controller.AddChangeCallback(function(ActiveControl, $ActiveControlElm) {
      if(null !== $ActiveControlElm && 'undefined' !== typeof $ActiveControlElm.data('control-input')) {
         var $InputElm = $($ActiveControlElm.data('control-input'));

         var Original;
         if($InputElm.is(':checkbox')) {
            Original = $InputElm.prop('checked');
         } else if($InputElm.is('select')) {
            Original = $InputElm.val();
         }

         var PreChangeCallback = null;
         var IsChanged = false;
         if('undefined' !== typeof $ActiveControlElm.data('control-input-set')) {
            if($InputElm.is(':checkbox')) {
               if(Original !== $ActiveControlElm.data('control-input-set')) {
                  $InputElm.prop('checked', $ActiveControlElm.data('control-input-set'));
                  PreChangeCallback = function(ChangeActiveControl, $ChangeActiveControlElm) {
                     // Not sure why this is needed.
                     $InputElm.prop('checked', Original);
                  };
                  IsChanged = true;
               }
            }
         } else if('undefined' !== typeof $ActiveControlElm.data('control-input-toggle')) {
            if($InputElm.is('select[multiple]')) {
               var Values = null === Original ? [] : Original;
               var Pos = Values.indexOf(String($ActiveControlElm.data('control-input-toggle')));
               if(-1 === Pos)
                  Values.push($ActiveControlElm.data('control-input-toggle'));
               else
                  Values.splice(Pos, 1);
               $ActiveControlElm.attr('aria-pressed', -1 === Pos);
               $InputElm.val(Values);
               IsChanged = true;
            }
         }

         if(IsChanged) {
            $InputElm.trigger('change');
            if(null !== PreChangeCallback)
               Controller.AddPreChangeCallback(PreChangeCallback);
            Controller.AddPostChangeCallback(function(ChangeActiveControl, $ChangeActiveControlElm) {
               $InputElm.trigger('change');
            });
         }
      }
   });


   // Initialize TinyMCE (https://github.com/tinymce/tinymce-dist)
   tinymce.baseURL = '/tpl/js/tinymce';

   // This is a workaround for https://github.com/tinymce/tinymce/issues/3739
   // The code below and the Controller.Refresh() call in init_instance_callback can be removed when the issue has been resolved.
   Controller.AddRefreshCallback(function(ActiveControl, $ActiveControlElm) {
      $('[data-control-visibility="'+ActiveControl+'"]').find('[data-tinymce]').addBack('[data-tinymce]').each(function() {
         var Editor = tinymce.get(this.id);
         if(null !== Editor)
            Editor.show();
      });
   });

   tinymce.init(
   {  selector: '[data-tinymce="html"]'
   ,  content_style: 'body {margin: 8px}'
   ,  relative_urls: false
   ,  element_format: 'html'
   ,  extended_valid_elements: '@[id|class|style|title|dir<ltr?rtl|lang|xml::lang|onclick|ondblclick|onmousedown|onmouseup|onmouseover|onmousemove|onmouseout|onkeypress|onkeydown|onkeyup],span'
   ,  entity_encoding: 'raw'
   ,  browser_spellcheck: true
   ,  image_caption: true
   ,  image_dimensions: false
   ,  paste_data_images: true
   ,  min_height: 300
   ,  images_upload_handler: function(BlobInfo, Success, Failure, Progress) {
         var FileUpload = $(tinymce.activeEditor.targetElm).data('file-upload');
         if(typeof FileUpload !== 'undefined') {
            // Upload image.
            var Blob = BlobInfo.blob();
            Blob.TinyMceUpload = {
               'Success': Success,
               'Failure': Failure,
               'Progress': Progress,
            };
            Dropzone.forElement('[data-dropzone-area="'+FileUpload+'"]').addFile(Blob);
         } else {
            // Store image as base64.
            Success('data:' + BlobInfo.blob().type + ';base64,' + BlobInfo.base64());
         }
      }
   ,  menubar: 'edit insert view format tools table'
   ,  toolbar:
      [  'undo redo | styleselect | bold italic | alignleft aligncenter alignright | bullist numlist | link image table'
      ]
   ,  plugins:
      [  'autolink'
      ,  'charmap'
      ,  'code'
      ,  'fullscreen'
      ,  'image'
      ,  'link'
      ,  'lists'
      ,  'nonbreaking'
      ,  'paste'
      ,  'searchreplace'
      ,  'table'
      ]
   ,  table_default_attributes:
      {  class: 'content-table'
      }
   ,  init_instance_callback: function(Editor) {
         var ControlVisibility = $(Editor.targetElm).data('control-visibility');
         if('undefined' !== typeof ControlVisibility) {
            $(Editor.editorContainer).attr('data-control-visibility', ControlVisibility);
            $(Editor.targetElm).removeAttr('data-control-visibility');
         }
         Controller.Refresh();
      }
   ,  setup: function(Editor) {
         Editor.on('change', function() {
            tinymce.triggerSave();
         });
      }
   });


   // Initialize JW Player (https://github.com/jwplayer/jwplayer)
   $('[data-jwplayer]').each(function() {
      var Sources = [];
      $(this).find('source').each(function() {
         Sources.push(
         {  file: $(this).attr('src')
         ,  label: $(this).data('jwplayer-video-label')
         });
      });

      jwplayer(this).setup(
      {  file: $(this).attr('src')
      ,  image: $(this).attr('poster')
      ,  title: $(this).data('jwplayer-title')
      ,  controls: this.hasAttribute('controls')
      ,  aspectratio: $(this).data('jwplayer-aspectratio')
      ,  width: '100%'
      ,  preload: $(this).attr('preload')
      ,  ga: {}
      ,  sources: Sources
      });
   });


   // Initialize Parsley (https://github.com/guillaumepotier/Parsley.js)
   Parsley.addValidator('uploadsComplete', {
      validateNumber: function(value) {
         return 0 === value;
      },
      messages:
      {  en: 'You must wait for all uploads to complete.'
      ,  de: 'Sie müssen warten, bis alle Uploads abgeschlossen sind.'
      }
   });

   // Initialize Dropzone.js (https://github.com/enyo/dropzone)
   $('[data-dropzone-url]').each(function() {
      var $this = $(this);
      $this.hide();
      var Id = this.id.slice(0, -6); // Remove trailing `|__Add`.
      var Name = this.name.slice(0, -9); // Remove trailing `[__Add][]`.

      var UpdateUploadCounter = function() {
         var Files = this.files.filter(function(File) {
            return [
               'uploading',
               'queued',
               'added'
            ].indexOf(File.status) !== -1;
         });
         $(this.element).find('input[data-dropzone-upload-count]').attr('value', Files.length);
         $(this.element).find('[data-dropzone-upload-count]:not(input)').text(Files.length);
         $(this.element).toggleClass('dz-uploading', 0 < Files.length);
         $(this.element).toggleClass('dz-uploaded', 0 === Files.length && 0 < this.files.length);
      }

      $('[data-dropzone-area="'+$this.attr('id')+'"]')
      .show()
      .dropzone(
      {  url: $this.data('dropzone-url')
      ,  createImageThumbnails: false
      ,  previewsContainer: '#' + $.escapeSelector(this.id) + '_Uploaded'
      ,  previewTemplate: new DOMParser().parseFromString($this.data('dropzone-tpl'), 'text/html').documentElement.textContent
      ,  timeout: 0
      ,  init: function() {
            this.NextId = 1;
            this.options.previewTemplate = this.options.previewTemplate.replace(new RegExp(EscapeRegExp(Id+'|__CreateItem'), 'g'), Id+'|__Id:dz'+this.NextId);
            this.options.previewTemplate = this.options.previewTemplate.replace(new RegExp(EscapeRegExp(Name+'[__CreateItem]'), 'g'), Name+'[__Id:dz'+this.NextId+']');
            this.on('addedfile', function(File) {
               $(File.previewElement).addClass('dz-added');
               $(File.previewElement).find('[data-dz-url]').attr('href', '#');
               $(File.previewElement).find('input[data-dz-name]').val(File.name);
               File.Id = this.NextId++;
               this.options.previewTemplate = this.options.previewTemplate.replace(new RegExp(EscapeRegExp(Id+'|__Id:dz'+File.Id), 'g'), Id+'|__Id:dz'+this.NextId);
               this.options.previewTemplate = this.options.previewTemplate.replace(new RegExp(EscapeRegExp(Name+'[__Id:dz'+File.Id+']'), 'g'), Name+'[__Id:dz'+this.NextId+']');
               InitAccordion($(File.previewElement).filter('details').find(' > summary'));
               InitAccordion($(File.previewElement).find('details > summary'));
               InitSelect2($(File.previewElement).find('[data-plugin-select2]'));
               Controller.Refresh();
            });
            this.on('success', function(File, Response) {
               $(File.previewElement).find('[data-dz-url]').attr('href', Response.Url);
               $.each(Response.Identifiers, function(Property, Value) {
                  $('input[name="' + Name + '[__Id:dz'+File.Id+']['+Property+']"]')
                  .filter(function(){ return $(this).val() === '';})
                  .val(Value);
               });
               if(File.hasOwnProperty('TinyMceUpload'))
                  File.TinyMceUpload.Success(Response.Url);
            });
            this.on('error', function(File, Message) {
               if(Array.isArray(Message))
                  $(File.previewElement).find('[data-dz-errormessage-html]').html(Message.join('<br>'));
               else
                  $(File.previewElement).find('[data-dz-errormessage-html]').text(Message);

               $(File.previewElement).find('input').prop('disabled', true);
               $(File.previewElement).find('select').prop('disabled', true);
               $(File.previewElement).find('label[for]').removeAttr('for');
               $(File.previewElement).find('a').each(function () {
                  var $Span = $('<span/>');
                  Array.prototype.slice.call(this.attributes).forEach(function(Attr) {
                     $Span.attr(Attr.name, Attr.value);
                  });
                  $(this).wrapInner($Span).children(0).unwrap();
                });
                if(File.hasOwnProperty('TinyMceUpload'))
                  File.TinyMceUpload.Failure(Array.isArray(Message) ? Message.join('<br>') : Message);
            });
            this.on('uploadprogress', function(File, Progress, BytesSent) {
                if(File.hasOwnProperty('TinyMceUpload'))
                  File.TinyMceUpload.Progress(Progress);
            });
            this.on('addedfile', UpdateUploadCounter);
            this.on('removedfile', UpdateUploadCounter);
            this.on('complete', UpdateUploadCounter);
         }
      });
   });

   // Initialize bootstrap-duration-picker (https://github.com/koss-lebedev/bootstrap-duration-picker)
   $('[data-duration]').each(function() {
      $(this).durationPicker(
         {  showDays: false
         ,  showSeconds: false
         ,  translations:
            {  day: i18n.ngettext('day', 'days', 1)
            ,  hour: i18n.ngettext('hour', 'hours', 1)
            ,  minute: i18n.ngettext('minute', 'minutes', 1)
            ,  second: i18n.ngettext('second', 'seconds', 1)
            ,  days: i18n.ngettext('day', 'days', 2)
            ,  hours: i18n.ngettext('hour', 'hours', 2)
            ,  minutes: i18n.ngettext('minute', 'minutes', 2)
            ,  seconds: i18n.ngettext('second', 'seconds', 2)
            }
         }
      );
   })

   // Update user's time zone.
   if(Intl.DateTimeFormat().resolvedOptions().timeZone !== Dp.TimeZone) {
      $.get(Dp.UriRoot + '/my-dynaplan/profile/set-timezone/' + encodeURIComponent(Intl.DateTimeFormat().resolvedOptions().timeZone));
   }
});
